import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioComponent,
      multi: true
    }
  ]
})
export class RadioComponent implements ControlValueAccessor {

  @Input() formControl: FormControl;
  @Input() options = [];
  @Input() horizontalAlign = false;
  @Input() showValidations = false;

  @Output() optionChange = new EventEmitter<any>();

  private selected: string;

  private onChangeCallBack: (_: any) => {};
  private onTouchedCallBack: (_: any) => {};

  onOptionChange(fn: MatRadioChange) {
    this.optionChange.emit(fn.value);
  }

  writeValue(value: any): void {
    this.selected = value;
  }

  registerOnChange(fn): void {
    this.onChangeCallBack = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallBack = fn;
  }

  get showErrors() {
    return this.showValidations || (this.formControl?.invalid && this.formControl?.touched);
  }
}
